export default {
    metaTitle: 'Ημερολόγιο',
    categories: {
        panelTitle: 'Ρυθμίσεις ημερολογίου',
        title: 'Κατηγορίες',
        subtitle: 'Οργάνωσε τα ραντεβού και τα γεγονότα σου με χρωματιστές κατηγορίες.',
        empty: 'Δεν έχεις κατηγορίες ακόμα',
        emptyText: 'Πάτα «Προσθήκη κατηγορίας» για να φτιάξεις την πρώτη σου.',
        namePlaceholder: 'Όνομα κατηγορίας...',
        add: 'Προσθήκη κατηγορίας',
        customColor: 'Προσαρμοσμένο χρώμα',
        field: 'Κατηγορία',
        all: 'Όλες οι κατηγορίες',
        googleConnected: 'Ενεργός συγχρονισμός',
        reconnect: 'Επανασύνδεση',
        connectGoogle: 'Σύνδεση με Google Calendar',
        typeGeneral: 'Γεγονός',
        typeAppointment: 'Ραντεβού',
        clearFilter: 'Καθαρισμός',
        filtersTitle: 'Φίλτρα ημερολογίου',
        filtersTooltip: 'Προβολή / φίλτρα',
        filtersHint: 'Χωρίς επιλογή, εμφανίζονται όλα.',
        viewTitle: 'Προβολή',
        showTime: 'Εμφάνιση ώρας',
        googleEvents: 'Γεγονότα Google Calendar',
        googleDescription: 'Συγχρόνισε τα ραντεβού σου με το Google Calendar σου.',
        twoWaySync: 'Αμφίδρομος συγχρονισμός',
        twoWaySyncHint: 'Όταν μετακινείς ή διαγράφεις ένα ραντεβού στο Google Calendar, μετακινείται ή ακυρώνεται και στο athlisis.',
    },
    google: {
        panelTitle: 'Γεγονός Google Calendar',
        notifyCheckbox: 'Ενημέρωση καλεσμένων με email',
        timesOnly: 'Από εδώ αλλάζει μόνο η ώρα. Τα υπόλοιπα αλλάζουν στο Google Calendar.',
        openInGoogle: 'Άνοιγμα στο Google Calendar',
        findClient: 'Εύρεση καρτέλας πελάτη',
        dragOnly: 'Τα γεγονότα πάνω από μία μέρα μετακινούνται σέρνοντάς τα στο ημερολόγιο.',
        notifyTitle: 'Να ενημερωθούν οι καλεσμένοι;',
        notifyBody: 'Η Google θα στείλει email με τη νέα ώρα σε όσους έχουν προσκληθεί.',
        notify: 'Αποστολή',
        dontNotify: 'Χωρίς αποστολή',
        reconnect: 'Το Google Calendar χρειάζεται επανασύνδεση από τις ρυθμίσεις του ημερολογίου.',
    },
    googleSync: {
        title: 'Αμφίδρομος συγχρονισμός με το Google Calendar',
        inviteIntro: 'Οι αλλαγές που κάνεις στα ραντεβού σου στο Google Calendar μπορούν πλέον να περνούν αυτόματα και στο athlisis.',
        intro: 'Οι αλλαγές που κάνεις στα ραντεβού σου στο Google Calendar περνούν αυτόματα και στο athlisis.',
        moveLabel: 'Μετακίνηση στο Google Calendar:',
        move: 'το ραντεβού μετακινείται και στο athlisis.',
        deleteLabel: 'Διαγραφή από το Google Calendar:',
        delete: 'το ραντεβού ακυρώνεται στο athlisis. Αν γίνει επαναφορά στο Google Calendar, ενεργοποιείται ξανά και στο athlisis.',
        past: 'Τα ολοκληρωμένα ραντεβού δεν ακυρώνονται αν τα διαγράψεις από το Google Calendar.',
        paymentMark: 'Τα ραντεβού που έχεις σημειώσει ως πληρωμένα ή απλήρωτα δεν αλλάζουν από το Google Calendar.',
        inviteHint: 'Μπορείς να ενεργοποιήσεις τον αμφίδρομο συγχρονισμό και αργότερα από τις ρυθμίσεις του ημερολογίου.',
        hint: 'Μπορείς να απενεργοποιήσεις τον αμφίδρομο συγχρονισμό από τις ρυθμίσεις του ημερολογίου.',
        turnOn: 'Ενεργοποίηση',
        later: 'Όχι τώρα',
        ok: 'Κατάλαβα',
    },
    newFeature: 'Νέο',
    cancelled: 'Ακυρωμένο',
    approved: 'Επιβεβαιωμένο',
    notesMore: 'περισσότερα',
    notesLess: 'λιγότερα',
    markAsCancelled: 'Ορισμός ως ακυρωμένο',
    revokeCancelled: 'Ορισμός ως μη-ακυρωμένο',
    viewProfile: 'Προφίλ πελάτη',
    kinds: {
        title: 'Είδος',
        customer: 'Ραντεβού με πελάτη',
        general: 'Γεγονός / Δραστηριότητα'
    },
    title: 'Τίτλος συμβάντος',
    startTime: 'Ώρα έναρξης',
    duration: 'Διάρκεια',
    endTime: 'Ώρα λήξης',
    minutes: '{time} λεπτά',
    googleMeet: 'Online συνεδρία (Google Meet)',
    addCustomer :'Δημιουργία νέου πελάτη',
    startGoogleMeet: 'Έναρξη συνεδρίας (Google meet)',
    create: 'Προσθήκη ραντεβού',
    update: 'Ενημέρωση ραντεβού',
    delete: 'Διαγραφή ραντεβού',
    errors: {
        missingCustomer: 'Παρακαλώ επιλέξτε έναν πελάτη ή αλλάξτε τον τύπο του συμβάντος.',
        missingDateTime: 'Παρακαλώ επιλέξτε ημερομηνία/ώρα έναρξης και λήξης.',
        invalidTime: 'Οι ώρες πρέπει να είναι στη μορφή ΩΩ:ΛΛ (π.χ. 09:30).',
        invalidMobileNumberForSms: 'Δεν μπορείτε να δημιουργήσετε ραντεβού με προγραμματισμένο SMS όταν ο αριθμός κινητού τηλεφώνου του πελάτη δεν είναι έγκυρος. Παρακαλώ απενεργοποιήστε το SMS ή ενημερώστε τον αριθμό στο προφίλ του πελάτη.',
        missingMobileNumberForSms: 'Δεν μπορείτε να δημιουργήσετε ραντεβού με προγραμματισμένο SMS όταν ο πελάτης δεν έχει καταχωρημένο αριθμό κινητού τηλεφώνου. Παρακαλώ απενεργοποιήστε το SMS ή προσθέστε έναν έγκυρο αριθμό στο προφίλ του πελάτη.'
    },
    updateMobileNumber: 'Ενημέρωση αριθμού κινητού',
    untitled: 'Συμβάν χωρίς τίτλο',
    findTab: '(Κλικ για εύρεση καρτέλας πελάτη)',
    onlyWithGoogle: 'Η λειτουργία είναι διαθέσιμη μόνο εάν έχετε κάνει σύνδεση του google calendar.',
    allDay: 'Ημέρα',
    timezoneRequired: 'Απαιτείται Timezone',
    timezoneDescription: 'Παρακαλώ επιλέξτε το timezone σας για να διασφαλίσετε ότι όλα τα γεγονότα του ημερολογίου εμφανίζονται με τις σωστές ώρες.',
    timezoneDifferentFromSystem: 'Διαφορετικό timezone από του συστήματος ({system})',
    toggleTime: 'Εμφάνιση/Απόκρυψη ώρας',
    sms: {
        segments: '{count} SMS ανά υπενθύμιση',
        title: 'SMS Υπενθύμιση',
        description: 'Αποστολή SMS υπενθύμισης για αυτό το ραντεβού',
        reminder: {
            hoursBefore: 'Ώρες πριν από το ραντεβού',
            description: 'Πότε να αποσταλεί η υπενθύμιση πριν από το ραντεβού'
        },
        noSubscription: {
            title: 'SMS Υπενθυμίσεις Διαθέσιμες',
            description: 'Εγγραφείτε στην υπηρεσία SMS για να στέλνετε αυτόματες υπενθυμίσεις στους πελάτες σας',
            cta: 'Προβολή Προγραμμάτων SMS'
        }
    }
}
